import React from "react";
import { Card, Container, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import { ReactComponent as ProfileIcon } from "../Assets/Icons/profileIcon.svg";
import { ReactComponent as DeleteIcon } from "../Assets/Icons/deleteIcon.svg";
import { ReactComponent as PasswordIcon } from "../Assets/Icons/passwordIcon.svg";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import EditIcon from "../Assets/Icons/editIcon.svg";
import EditProfileModal from "../Components/EditProfileModal";
import { Link } from "react-router-dom";

export default function AdminProfileSetting() {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <Container fluid>
      <EditProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      <PageLayout>
        <div>
          <h1 className="admin-profile-setting-heading">Settings</h1>
          <div className="profile-detail-parent">
            <Card
              id='profile-setting-card-list'
              className="profile-seetting-card"
            >
              <div className="admin-setting-list-con">
                <Link style={{textDecoration: 'inherit'}} to="/admin-profile-setting">
                <div className="admin-setting-list">
                  <ProfileIcon style={{ width: "1.5rem" }} fill="black" />
                  <p style={{ color: "black", fontWeight: "700" }}>Profile</p>
                </div>
                </Link>
                <Link style={{textDecoration: 'inherit'}} to="/admin-password-request">
                <div className="admin-setting-list">
                  <PasswordIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Password</p>
                </div>
                </Link>
                <Link style={{textDecoration: 'inherit'}} to="/admin-delete-account">
                <div className="admin-setting-list">
                  <DeleteIcon style={{ width: "1.5rem" }} fill="#A6A6A6" />
                  <p style={{ color: "#A6A6A6" }}>Delete Account</p>
                </div>
                </Link>
              </div>
            </Card>
            <Card
              style={{ paddingBottom: "4rem" }}
              className="profile-seetting-card"
            >
              <div className="profile-seeting-sec-one">
                <div className="profile-setting-profile">
                  <img src={ProfileImg} />
                  <p>Admin Name</p>
                </div>
                <Button onClick={() => setModalShow(true)} variant="light">
                  Edit
                  <img style={{width: '1rem', height: '1rem'}} src={EditIcon} />
                </Button>
              </div>
              <div className="divider"></div>
              <div className="profile-details">
                <div className="profile-details-sec-con">
                  <div className="profile-details-sec">
                    <p>Name</p>
                    <h2>Naseem Muneer</h2>
                  </div>
                  <div className="profile-details-sec">
                    <p>Address</p>
                    <h2>Islamabad, Pakistan</h2>
                  </div>
                  <div className="profile-details-sec">
                    <p>Country</p>
                    <h2>Pakistan</h2>
                  </div>
                </div>
                <div className="profile-details-sec-con">
                  <div className="profile-details-sec">
                    <p>Email Address</p>
                    <h2>naseembaloch7524@gmail.com</h2>
                  </div>
                  <div className="profile-details-sec">
                    <p>Phone Number</p>
                    <h2>+923160598938</h2>
                  </div>
                  <div className="profile-details-sec">
                    <p>Shop Address</p>
                    <h2>Islamabad, Pakistan</h2>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
